export default __webpack_public_path__ + "static/media/mgroup-logo.11258098.png";